/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { EventInfo } from "utility";

type Props = {
  THEOPlayerElementHeight: number;
  isDarkModeEnabled: boolean;
  pseudoCart: (ProductData & { count: number })[];
  displayEvent: EventInfo;
  removeCartItem: (itemData: ProductData) => void;
};

export const StreamingLiveCommerceItemListV2: React.FC<Props> = (props) => {
  const { t } = useI18n();
  const classesLiveCommerceCartItemListDesign = liveCommerceCartItemListDesign({
    THEOPlayerElementHeight: props.THEOPlayerElementHeight,
    isDarkModeEnabled: props.isDarkModeEnabled,
  });
  const ticketsToBePurchasedList = props.pseudoCart.filter(
    (item) => item.productType === "ticket"
  );
  const goodsToBePurchasedList = props.pseudoCart.filter(
    (item) => item.productType === "goods"
  );

  return (
    <React.Fragment>
      {props.pseudoCart.length === 0 ? (
        <div css={classesLiveCommerceCartItemListDesign.yourCartIsEmpty}>
          <p>{t("streaming.commerceCart.emptyCart")}</p>
        </div>
      ) : (
        <div>
          <p>{t("streaming.commerceCart.product")}</p>
          {ticketsToBePurchasedList.length > 0 && (
            <React.Fragment>
              {/* <div css={classesLiveCommerceCartItemListDesign.categoryHeader}>
                            <p>TICKET</p>
                          </div> */}
              <div css={classesLiveCommerceCartItemListDesign.item}>
                <div css={classesLiveCommerceCartItemListDesign.headerImage}>
                  <img
                    src={props.displayEvent.thumbnail}
                    alt={props.displayEvent.title}
                  />
                </div>
                <div css={classesLiveCommerceCartItemListDesign.headerText}>
                  <h3>{props.displayEvent.title}</h3>
                </div>
              </div>
              {ticketsToBePurchasedList.map((ticket, index) => {
                return (
                  <div
                    css={classesLiveCommerceCartItemListDesign.item}
                    key={index}
                  >
                    <div css={classesLiveCommerceCartItemListDesign.ticketText}>
                      <p css={classesLiveCommerceCartItemListDesign.goodsName}>
                        {ticket.name}
                      </p>
                      <p css={classesLiveCommerceCartItemListDesign.price}>
                        ¥{ticket.price_jpy.toLocaleString()}
                      </p>
                    </div>
                    {/* <div css={classesLiveCommerceCartItemListDesign.operation}> */}
                    {/* <div css={classesLiveCommerceCartItemListDesign.selectNumButton}>
                                      <div onClick={ () => decrementNum(ticket) }><RemoveIcon/></div>
                                      <p>{ticket.count}</p>
                                      <div onClick={ () => incrementNum(ticket) }><AddIcon/></div>
                                    </div> */}
                    <p
                      css={classesLiveCommerceCartItemListDesign.remove}
                      onClick={() => props.removeCartItem(ticket)}
                    >
                      {t("streaming.commerceCart.remove")}
                    </p>
                    {/* </div> */}
                  </div>
                );
              })}
            </React.Fragment>
          )}

          {goodsToBePurchasedList.length > 0 &&
            goodsToBePurchasedList.map((cartItem, index) => {
              return (
                <div
                  css={classesLiveCommerceCartItemListDesign.item}
                  key={index}
                >
                  <div css={classesLiveCommerceCartItemListDesign.image}>
                    <img src={cartItem.thumbnail} alt={cartItem.name} />
                  </div>
                  <div css={classesLiveCommerceCartItemListDesign.text}>
                    <p css={classesLiveCommerceCartItemListDesign.goodsName}>
                      {cartItem.name}
                    </p>
                    <p css={classesLiveCommerceCartItemListDesign.size}>
                      {cartItem.subClassName}
                    </p>
                    <p css={classesLiveCommerceCartItemListDesign.price}>
                      ¥{cartItem.price_jpy.toLocaleString()}/
                      {t("streaming.commerceCart.quantity")}
                      {cartItem.count}
                    </p>
                  </div>
                  {/* <div css={classesLiveCommerceCartItemListDesign.operation}>
                      <div css={classesLiveCommerceCartItemListDesign.selectNumButton}>
                        <div onClick={() => decrementNum(cartItem)}>
                          <RemoveIcon />
                        </div>
                        <p>{cartItem.count}</p>
                        <div onClick={() => incrementNum(cartItem)}>
                          <AddIcon />
                        </div>
                      </div>
                      <p
                        css={classesLiveCommerceCartItemListDesign.remove}
                        onClick={() => removeCartItem(cartItem)}
                      >
                        {t("streaming.commerceCart.remove")}
                      </p>
                    </div> */}
                </div>
              );
            })}
        </div>
      )}
    </React.Fragment>
  );
};

type LiveCommerceCartDesignProps = {
  THEOPlayerElementHeight: number;
  isDarkModeEnabled: boolean;
};

const liveCommerceCartItemListDesign = (props: LiveCommerceCartDesignProps) => {
  const textColorInDarkMode = props.isDarkModeEnabled
    ? css`
        color: #fff;
      `
    : null;
  // ダークモードがオフの時だけボーダーを表示
  // const categoryHeader = css`
  //   padding: 8px 0;
  //   border-bottom: 1px solid #e0e0e0;
  //   background-color: #f4f4f4;
  //   p{
  //     padding: 0 12px;
  //     font-size: 15px;
  //     font-weight: bold;
  //   }
  // `
  const headerImage = css`
    width: 150px;
    margin-right: 10px;
    img {
      width: 100%;
    }
  `;
  const headerText = css`
    width: calc(100% - 160px);
    h3 {
      margin-bottom: 16px;
      ${textColorInDarkMode}
      font-size: 16px;
      font-weight: normal;
      line-height: 1.3em;
    }
  `;
  const item = css`
    display: flex;
    padding: 10px 0;
    border-top: 1px solid #e0e0e0;
  `;
  const image = css`
    width: 90px;
    height: 90px;
    margin-right: 10px;
    img {
      width: 100%;
    }
  `;
  const text = css`
    width: calc(100% - 180px);
  `;
  const ticketText = css`
    width: calc(100% - 80px);
  `;
  const goodsName = css`
    display: box;
    height: 2.4em;
    margin-bottom: 10px;
    ${textColorInDarkMode}
    font-size: 14px;
    line-height: 1.3em;
    /* stylelint-disable-next-line property-no-unknown */
    box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-line-clamp: 2;
  `;
  const size = css`
    margin-bottom: 10px;
    color: #b1b1b1;
    font-size: 14px;
  `;
  const price = css`
    ${textColorInDarkMode}
  `;
  const operation = css`
    width: 70px;
    margin-left: 10px;
  `;
  const selectNumButton = css`
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    input,
    div,
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(100% / 3);
    }
    input,
    div {
      padding: 4px 7px;
    }
    input,
    p {
      font-size: 14px;
      text-align: center;
      background-color: #fff;
    }
    div {
      border-left: 1px solid #e5e5e5;
      background-color: #f4f4f4;
      cursor: pointer;
      svg {
        width: 15px;
        height: 15px;
      }
    }
  `;
  const remove = css`
    color: #b1b1b1;
    font-size: 12px;
    text-align: right;
    cursor: pointer;
  `;
  const yourCartIsEmpty = css`
    padding: 20px 0;
    p {
      ${textColorInDarkMode}
      font-size: 14px;
      text-align: center;
    }
  `;
  return {
    // categoryHeader,
    headerImage,
    headerText,
    item,
    image,
    text,
    ticketText,
    goodsName,
    size,
    price,
    operation,
    selectNumButton,
    remove,
    yourCartIsEmpty,
  };
};
